import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero, Shop, HowItWorks, About, Faq } from "@/components/HomeSections";
import { Testimonials } from "@/components/Testimonials";
import { site } from "@/data/store";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    document.title = `${site.brandName} — ${site.tagline}`;
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 50);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Shop />
      <HowItWorks />
      <About />
      <Testimonials />
      <Faq />
    </main>
  );
}
